module.exports = __webpack_public_path__ + "img/about_trademark.7b2b2063.png";